module.exports = __webpack_public_path__ + "static/img/product_images_27_h5_zh.5ea3ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_27_h5_zh.png
// module id = /RgP
// module chunks = 34